"use client";

import { VisualEditing } from "next-sanity/visual-editing";
import React, { Suspense } from "react";
import { SanityPreviewBar } from "./SanityPreviewBar";

export function SanityPreviewVisualEditing() {
  return (
    <Suspense>
      <SanityPreviewBar />
      <VisualEditing />
    </Suspense>
  );
}
